import './assets/main.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'animate.css';

//rem等比适配配置文件

const resetInitialHomeScroll = () => {
	if (window.location.pathname !== '/' || window.location.hash) return

	if ('scrollRestoration' in window.history) {
		window.history.scrollRestoration = 'manual'
	}

	const scrollToTop = () => {
		window.scrollTo({ left: 0, top: 0, behavior: 'auto' })
	}

	scrollToTop()
	window.addEventListener(
		'load',
		() => {
			scrollToTop()
			window.requestAnimationFrame(scrollToTop)
		},
		{ once: true },
	)
}

resetInitialHomeScroll()

try {
	console.log('Starting Vue app...')
	const app = createApp(App)
	app.use(router)
	app.mount('#app')
	console.log('Vue app mounted successfully')
} catch (error) {
	console.error('Failed to mount Vue app:', error)
	// 在页面上显示错误信息
	const appElement = document.getElementById('app')
	if (appElement) {
		appElement.innerHTML = `
      <div style="padding: 20px; color: red; font-family: monospace; background: #fff;">
        <h2>Application Error</h2>
        <p>Failed to load the application. Please check the console for details.</p>
        <pre>${error}</pre>
      </div>
    `
	}
}
